import client from './client'
import { buildListParams } from '../utils/pagination'

export function fetchTracks({ page, perPage, season, wheelSize } = {}) {
  const params = buildListParams({ page, perPage, season, wheelSize })
  return client.get('/api/v1/tracks', { params })
}

export function fetchPublicTracks({ sort = 'new', page, perPage, season, wheelSize } = {}) {
  const params = buildListParams({ page, perPage, season, wheelSize, extra: { sort } })
  return client.get('/api/v1/public_tracks', { params })
}

export function fetchUserPublicTracks(userId) {
  return client.get(`/api/v1/users/${userId}/public_tracks`)
}

export function fetchUserPublicTracksByUsername(username) {
  return client.get(`/api/v1/u/${encodeURIComponent(username)}/tracks`)
}

export function fetchTrack(id) {
  return client.get(`/api/v1/tracks/${id}`)
}

export function downloadTrackGpx(id) {
  return client.get(`/api/v1/tracks/${id}/gpx`, { responseType: 'blob' })
}

export function createTrackFromPoints(payload) {
  return client.post('/api/v1/tracks', { track: payload })
}

export function updateTrack(id, payload = {}, { photos = [], photoMetadata = [], removePhotoIds = [] } = {}) {
  const hasPhotos = photos.length > 0 || removePhotoIds.length > 0
  const hasTrackFields = Object.keys(payload).length > 0

  if (!hasPhotos) {
    return client.patch(`/api/v1/tracks/${id}`, { track: payload })
  }

  const formData = new FormData()

  if (hasTrackFields) {
    if (payload.name !== undefined) formData.append('track[name]', payload.name)
    if (payload.description !== undefined) formData.append('track[description]', payload.description)
    if (payload.public !== undefined) formData.append('track[public]', payload.public ? '1' : '0')
    if (payload.allow_comments !== undefined) {
      formData.append('track[allow_comments]', payload.allow_comments ? '1' : '0')
    }
    if (payload.difficulty_profiles !== undefined) {
      formData.append('track[difficulty_profiles]', JSON.stringify(payload.difficulty_profiles))
    }
  }

  photos.forEach((photo) => formData.append('photos[]', photo))
  if (photoMetadata.length) {
    formData.append('photo_metadata', JSON.stringify(photoMetadata))
  }
  removePhotoIds.forEach((photoId) => formData.append('remove_photo_ids[]', photoId))

  return client.patch(`/api/v1/tracks/${id}`, formData)
}

export function uploadGpx(file, metadata = {}) {
  const formData = new FormData()
  formData.append('file', file)

  if (metadata.name) {
    formData.append('name', metadata.name)
  }
  if (metadata.description) {
    formData.append('description', metadata.description)
  }
  if (metadata.difficulty_profiles?.length) {
    formData.append('difficulty_profiles', JSON.stringify(metadata.difficulty_profiles))
  }
  if (metadata.public !== undefined) {
    formData.append('public', metadata.public ? '1' : '0')
  }

  const photos = metadata.pendingPhotos || []
  photos.forEach((photo) => formData.append('photos[]', photo.file))
  if (photos.length) {
    formData.append(
      'photo_metadata',
      JSON.stringify(
        photos.map((photo) => (photo.gps ? { lat: photo.gps.lat, lng: photo.gps.lng } : {}))
      )
    )
  }

  return client.post('/api/v1/tracks', formData)
}

export function deleteTrack(id) {
  return client.delete(`/api/v1/tracks/${id}`)
}

export function updateVisibilitySettings(trackId, isPublic) {
  return client.patch(`/api/v1/tracks/${trackId}/visibility_settings`, {
    public: isPublic,
  })
}
